import { IconButton, IconCheckbox } from '@zillow/constellation';
import React from 'react';
import { toggleQuickTasks } from 'store/order/quickForms/quickFormsSlice';
import { useAppDispatch } from 'store/store';

export const QuickTasks = () => {
  const dispatch = useAppDispatch();

  return (
    <IconButton
      icon={<IconCheckbox />}
      title={'Task List'}
      bare
      size={'sm'}
      onClick={() => dispatch(toggleQuickTasks())}
    />
  );
};
